import React from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
  const borderColor = type === 'success' ? 'border-green-500' : 'border-red-500';
  const textColor = type === 'success' ? 'text-green-700' : 'text-red-700';
  const bgColor = type === 'success' ? 'bg-green-50' : 'bg-red-50';
  const icon = type === 'success' ? '\u2713' : '\u2717';
  const iconBg = type === 'success' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className={`${bgColor} border ${borderColor} rounded-lg shadow-xl max-w-md w-full mx-4 p-6`}>
        <div className="flex flex-col items-center text-center space-y-4">
          <div className={`w-12 h-12 rounded-full ${iconBg} flex items-center justify-center text-2xl`}>
            {icon}
          </div>
          <p className={`text-sm font-medium ${textColor}`}>{message}</p>
          <button
            onClick={onClose}
            className="px-6 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-alps-primary"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
